/* Stylesheet */

.item_container {
  position: absolute;
  min-height: 92px;
  max-height: 192px;
  width: 100%;
  border-radius: 0px 0px 8px 8px;
  overflow: auto;
  z-index: 100;
  background: #294162;

  .item {
    --padding-start: 21px;
    --min-height: 48px;
    --color: #c3cddc;
    --color-hover: #c3cddc;
    --background: transparent;
    --color-activated: #c3cddc;
  }
}
